import { render, staticRenderFns } from "./updateLinkageRiskWeight.vue?vue&type=template&id=69740161&lang=pug"
import script from "./updateLinkageRiskWeight.vue?vue&type=script&lang=js"
export * from "./updateLinkageRiskWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports